// extracted by mini-css-extract-plugin
module.exports = {"announcementPanel":"AnnouncementPanel_announcementPanel__L9fjX","deleteButton":"AnnouncementPanel_deleteButton__1BgS2"};